import { BlockedUser, BlockStatus } from '../types/blockedUser';
import { ConnectionResult } from '../types/connectionResult';
import { User } from '../types/user';
import { UserInput } from '../types/userInput';

export interface GetUserResponse {
  getUser: User;
}

export interface GetUserVariables {
  input: UserInput;
}

export interface GetBlockedUsersResponse {
  getBlockedUsers: ConnectionResult<BlockedUser>;
}

export interface GetBlockedUsersVariables {
  limit?: number;
  nextToken?: string;
}

export interface GetBlockStatusResult {
  blockStatus: BlockStatus | null;
  chatEnabled: boolean;
}

export interface GetBlockStatusQueryResponse {
  getBlockStatus: GetBlockStatusResult;
}

export interface GetBlockStatusVariables {
  receiverId: string;
}

export const getUserQuery = `
  query GetUser($input: UserInput!) {
    getUser(input: $input) {
      id
      name
      photo
      phones
      chatEnabled
      createdAt
      updatedAt
    }
  }
`;

export const getBlockedUsersQuery = `
  query GetBlockedUsers($limit: Int, $nextToken: String) {
    getBlockedUsers(limit: $limit, nextToken: $nextToken) {
      items {
        userId
        blockedUserId
        createdAt
      }
      nextToken
    }
  }
`;

export const getBlockStatusQuery = `
  query GetBlockStatus($receiverId: ID!) {
    getBlockStatus(receiverId: $receiverId) {
      blockStatus
      chatEnabled
    }
  }
`;
